import { qsa } from "@meduza/dom";

import { section } from "@/glow";
import playButtonBlock from "@/lib/play-button-block";
import { animateRichText, shouldAnimate } from "@/lib/animation";

const selectors = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};

section("rich-text", {
  onLoad() {
    const playButtonVideos = qsa(selectors.playButtonVideo, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(block =>
        playButtonBlock(block.closest(selectors.playButtonBlock))
      );
    }

    if (shouldAnimate(this.container)) {
      this.animateRichText = animateRichText(this.container);
    }
  },

  onUnload() {
    this.playButtons && this.playButtons.forEach(button => button.unload());
    this.animateRichText?.destroy();
  },
});
